import { useMutation, useQueryClient } from '@tanstack/react-query';
import { gqlFetcher, type MutationOptions } from '../fetcher';
import { CreateParticipantTaskTemplate } from '../mutations/createParticipantTaskTemplate.mutation';
import type {
  CreateParticipantTaskTemplateMutation,
  CreateParticipantTaskTemplateMutationVariables,
} from '../types';

export const useCreateParticipantTaskTemplateMutation = (
  options?: MutationOptions<
    CreateParticipantTaskTemplateMutation,
    CreateParticipantTaskTemplateMutationVariables
  >,
) => {
  const queryClient = useQueryClient();

  return useMutation(gqlFetcher(CreateParticipantTaskTemplate), {
    ...options,
    onSettled: async (resp, error, variables, ctx) => {
      await options?.onSettled?.(resp, error, variables, ctx);

      queryClient.invalidateQueries({
        predicate: (query) => query.queryKey.includes('participantTaskTemplates'),
      });
    },
  });
};
